'use strict';
module.exports = {};

var errorMaxLength = 47;

module.exports.errorLenghtOverMax = function(errorText, isLongMessage) {
    return !Odigeo._.isUndefined(isLongMessage) ? !!isLongMessage : (!!errorText && errorText.length > errorMaxLength);
};

module.exports.clearErrors = function(allInputs, socialErrors) {
    Odigeo._.each(allInputs, function(element) {
        const $wrapper = $(element).closest('.input_wrapper');
        $wrapper.removeClass('invalid invalid-long');
        if (Odigeo.AB.isCssVariationMobile) {
            $wrapper.find('.prisma-label-error').addClass('odf-hidden');
        }
    }, this);
    Odigeo._.each(socialErrors, function(element) {
        $(element).removeClass('invalid invalid-long');
    }, this);
};

module.exports.showError = function(errorText, $wrapper, isLongMessage) {
    let isLongError = this.errorLenghtOverMax(errorText, isLongMessage);
    const longErrorClass = Odigeo.AB.isCssVariationDesktop ? 'invalid invalid-long' : 'invalid-long';
    // Exception in case japanese language
    isLongError = (Odigeo.SessionScope.website === 'ja' &&
    Odigeo.SessionScope.flow === 'mobile' &&
    errorText.length > 25) ? true : isLongError;
    $wrapper.find(isLongError ? '.error_long_message' : '.error_message').text(errorText);
    $wrapper.addClass(isLongError ? longErrorClass : 'invalid');
    if (Odigeo.AB.isCssVariationMobile) {
        $wrapper.find('.prisma-label-error').removeClass('odf-hidden');
    }
};

module.exports.checkValidity = function(allInputs, widgetId) {
    var fieldErrors = Odigeo._.reduce(allInputs, function(accErrors, el) {
        return $.merge(accErrors, this._validateOneField($(el)));
    }, [], this);
    Odigeo._.each(fieldErrors, function(element) {
        this._showError(element, widgetId);
    }, this);
    return fieldErrors;
};

module.exports._validateOneField = function($target) {
    var errorLog = [];
    var valData = $target.data();
    if (!valData || !valData.validationType) {
        return errorLog;
    }
    var value = $target.is('input') ? $target.val() : 'click';
    if (Odigeo._.isEmpty(value)) {
        errorLog.push({index: valData ? valData.name : '', key: 'empty'});
    } else if (valData && valData.validationType && !Odigeo.Utils.isValid(valData.validationType, value)) {
        errorLog.push({index: valData.name, key: 'invalid'});
    }

    return errorLog;
};

module.exports._showError = function(error, widgetId) {
    var $container = widgetId.find('[data-name=' + error.index + ']');
    var errText = $container.data(error.key);
    var $inputWrapper = $container.closest('.input_wrapper');
    this.showError(errText, $inputWrapper);
};

